import type { RouteMap } from "#vue-router"

export function useHumanRiskOnboardingProgress() {
  const route = useRoute()
  const { t } = useI18n()

  const steps = computed(
    () =>
      [
        {
          link: { name: "human-risk-intelligence-onboarding" },
          title: t("human_risk_intelligence.onboarding.steps.introduction"),
        },
        {
          link: {
            name: "human-risk-intelligence-onboarding-training-strategy",
          },
          title: t(
            "human_risk_intelligence.onboarding.steps.training_strategy",
          ),
        },
        {
          link: { name: "human-risk-intelligence-onboarding-interventions" },
          title: t("human_risk_intelligence.onboarding.steps.interventions"),
        },
        {
          link: { name: "human-risk-intelligence-onboarding-summary" },
          title: t("human_risk_intelligence.onboarding.steps.review"),
        },
      ] as const satisfies {
        link: { name: keyof RouteMap }
        title: string
      }[],
  )

  const completedSteps = computed(() => {
    const currentIndex = steps.value.findIndex(
      (step) => step.link.name == route.name,
    )

    if (currentIndex < 0) {
      return []
    }

    return steps.value.slice(0, currentIndex).map((step) => step.link.name)
  })

  return {
    completedSteps,
    steps,
  }
}
